var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 296,
    height: 173,
    viewBox: "0 0 296 173",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.646851,
    width: 295.088,
    height: 172.135,
    rx: 9.83627,
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_481_2412",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 66,
    width: 158,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.675 66.9503H69.9062V106.478H226.675V66.9503Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_481_2412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.6991 99.7205C79.5507 99.7205 78.5118 99.0233 78.129 97.9506L70.0906 77.4089C69.5438 76.0145 70.2547 74.4591 71.6764 73.9228C73.0982 73.3865 74.684 74.0837 75.2308 75.4782L80.6444 89.3693L86.058 75.4782C86.4408 74.4055 87.4798 73.7083 88.6281 73.7083C89.7764 73.7083 90.8154 74.4055 91.1982 75.4782L96.6118 89.3693L102.025 75.4782C102.572 74.0837 104.158 73.3865 105.58 73.9228C107.002 74.4591 107.712 76.0145 107.166 77.4089L99.2366 97.9506C98.8538 99.0233 97.8148 99.7205 96.6665 99.7205C95.5182 99.7205 94.4791 99.0233 94.0964 97.9506L88.6828 84.0595L83.2692 97.9506C82.8317 99.0233 81.8474 99.7205 80.6991 99.7205Z",
    fill: "#2E3038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.202 79.1251H148.234C146.703 79.1251 145.445 77.8916 145.445 76.3898C145.445 74.8881 146.703 73.6545 148.234 73.6545H164.202C165.733 73.6545 166.991 74.8881 166.991 76.3898C166.991 77.8916 165.733 79.1251 164.202 79.1251Z",
    fill: "#2E3038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.37 89.4229H148.285C146.754 89.4229 145.496 88.1894 145.496 86.6876C145.496 85.1859 146.754 83.9523 148.285 83.9523H160.37C161.901 83.9523 163.159 85.1859 163.159 86.6876C163.159 88.1894 161.901 89.4229 160.37 89.4229Z",
    fill: "#2E3038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.252 99.7205H148.285C146.754 99.7205 145.496 98.4869 145.496 96.9852C145.496 95.4835 146.754 94.2499 148.285 94.2499H164.252C165.784 94.2499 167.041 95.4835 167.041 96.9852C167.041 98.4869 165.784 99.7205 164.252 99.7205Z",
    fill: "#2E3038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.268 79.1251H175.301C173.77 79.1251 172.512 77.8916 172.512 76.3898C172.512 74.8881 173.77 73.6545 175.301 73.6545H191.268C192.799 73.6545 194.057 74.8881 194.057 76.3898C194.057 77.8916 192.799 79.1251 191.268 79.1251Z",
    fill: "#2E3038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.385 89.4229H175.301C173.77 89.4229 172.512 88.1894 172.512 86.6876C172.512 85.1859 173.77 83.9523 175.301 83.9523H187.385C188.917 83.9523 190.174 85.1859 190.174 86.6876C190.174 88.1894 188.917 89.4229 187.385 89.4229Z",
    fill: "#2E3038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.268 99.7205H175.301C173.77 99.7205 172.512 98.4869 172.512 96.9852C172.512 95.4835 173.77 94.2499 175.301 94.2499H191.268C192.799 94.2499 194.057 95.4835 194.057 96.9852C194.057 98.4869 192.799 99.7205 191.268 99.7205Z",
    fill: "#2E3038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.89 99.7205C206.359 99.7205 205.102 98.4869 205.102 96.9852V76.4435C205.102 74.9418 206.359 73.7083 207.89 73.7083C209.422 73.7083 210.679 74.9418 210.679 76.4435V85.3721L210.771 85.2832C210.881 85.096 211.014 84.919 211.172 84.7568C211.363 84.5684 211.576 84.4131 211.801 84.2906L221.944 74.5128C223.038 73.4401 224.788 73.4938 225.881 74.5664C226.975 75.6391 226.92 77.3554 225.826 78.428L217.226 86.7479L225.772 95.0007C226.865 96.0734 226.865 97.7897 225.826 98.8623C225.28 99.4523 224.569 99.7205 223.858 99.7205C223.147 99.7205 222.436 99.4523 221.889 98.916L213.261 90.5835L210.679 93.081V96.9852C210.679 98.4869 209.422 99.7205 207.89 99.7205Z",
    fill: "#2E3038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.541 106.478H121C115.805 106.478 111.594 102.348 111.594 97.2532V76.1752C111.54 71.08 115.805 66.9503 121 66.9503H191.595C196.79 66.9503 201.001 71.08 201.001 76.1752V97.2532C201.001 102.348 196.735 106.478 191.541 106.478ZM121 69.6319C117.336 69.6319 114.328 72.5818 114.328 76.1752V97.2532C114.328 100.847 117.336 103.796 121 103.796H191.595C195.259 103.796 198.267 100.847 198.267 97.2532V76.1752C198.267 72.5818 195.259 69.6319 191.595 69.6319H121Z",
    fill: "#6788F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.186 94.3036H121.219C121.054 94.3036 120.89 94.3036 120.672 94.3573C119.414 94.5718 118.43 95.6981 118.43 97.0389C118.43 98.3798 119.414 99.4524 120.672 99.7206C120.836 99.7743 121 99.7743 121.219 99.7743H137.186C138.717 99.7743 139.975 98.5407 139.975 97.0389C139.975 95.4836 138.717 94.3036 137.186 94.3036Z",
    fill: "#6788F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.726 79.0715C120.89 79.1251 121.054 79.1251 121.273 79.1251H137.186C138.717 79.1251 139.975 77.8916 139.975 76.3898C139.975 74.8881 138.717 73.6545 137.186 73.6545H121.219C121.054 73.6545 120.89 73.6545 120.672 73.7082C119.414 73.9226 118.43 75.049 118.43 76.3898C118.484 77.7306 119.414 78.8569 120.726 79.0715Z",
    fill: "#6788F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.726 89.3693C120.89 89.4229 121.054 89.4229 121.273 89.4229H133.358C134.889 89.4229 136.147 88.1894 136.147 86.6876C136.147 85.1859 134.889 83.9523 133.358 83.9523H121.219C121.054 83.9523 120.89 83.9523 120.672 84.006C119.414 84.2205 118.43 85.3468 118.43 86.6876C118.484 88.0284 119.414 89.1548 120.726 89.3693Z",
    fill: "#6788F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.3af14127ba19a4d711da63e6eb31595b.svg";
export { ForwardRef as ReactComponent };